import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import {
  HeadedContainer,
  HeadedContainerProps,
} from "features/CenterContent/VehicleDetails/shared/HeadedContainer";
import { Box, VStack } from "shared/components/Spor";
import { FCWC } from "shared/utils/FCWC";
import styled, { RuleSet } from "styled-components";

const Header = styled(VStack)<{
  $panelStyle: RuleSet<object>;
}>`
  ${({ $panelStyle }) => $panelStyle};
  border-bottom: none; /* Since a DashedLine follow after */
`;

/**
 * HeadedContainer, but its header is sticky. Use mock data and look at <TrainDetails/> to see its usage.
 * HeadedContainerSticky must be placed in a StickyController
 */
export const HeadedContainerSticky: FCWC<HeadedContainerProps> = ({
  panelStyle,
  header,
  headerHeight,
  variant,
  children,
  ...props
}) => (
  <>
    <Box className="sticky-container">
      <Header
        $panelStyle={panelStyle}
        minH={headerHeight}
        maxH={headerHeight}
        justifyContent="center"
      >
        {header}
      </Header>
      <DashedLine variant={variant} />
    </Box>
    <HeadedContainer
      panelStyle={panelStyle}
      header={header}
      headerHeight={headerHeight}
      variant={variant}
      {...props}
    >
      {children}
    </HeadedContainer>
  </>
);
